module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-13.ff455b56.png";